import VueCookies from 'vue-cookies';

// 이벤트 모달창 쿠키 체크
const modalCookieCheck = () => {
   const useCookie = VueCookies.isKey('eventModalCookie');
   return useCookie ? false : true;
}

export default { modalCookieCheck }